import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-property-decorator";
import { Line } from 'vue-chartjs';
const dbBackground = 'rgba(32, 36, 39, 1)';
// const dbTitle = 'rgba(255, 255, 255, 1)'
const cGreen1 = 'rgba(0, 241, 155, 1)';
const cGreen2 = 'rgba(0, 150, 136, 1)';
const cWhite1 = 'rgba(255, 255, 255, 1)';
// const dbGrey = 'rgba(255, 255, 255, 1)'
// const dbGreen = 'rgba(0, 241, 155, 1)'
// const dbOrange = 'rgba(255, 169, 0, 1)'
// const dbRed = 'rgba(239, 83, 80, 1)'
const arrowUp = {
    x: 40,
    y: 140,
    l: 70,
    w: 10,
    hw: 40,
    hh: 50
};
const arrowDown = {
    x: 40,
    y: 15,
    l: -70,
    w: 10,
    hw: 40,
    hh: -50
};
let chart = class chart extends Vue {
    mounted() {
        let aminateProgress = 1;
        // this.$data._plugins.push({
        //   id: 'arrow-plugin',
        //   afterDraw(chart: any) {
        //     if (chart.config.options.elements.arrow) {
        //       var ctx = chart.chart.ctx
        //       var arrow = chart.config.options.elements.arrow
        //       let l = chart.chartArea.left
        //       let t = chart.chartArea.top
        //       let w = chart.chartArea.right - chart.chartArea.left
        //       let h = chart.chartArea.bottom - chart.chartArea.top
        //       let xScale = w / 500
        //       let yScale = h / 160
        //       let dir = arrowDown
        //       // dir = arrowUp
        //       let d = {
        //         x: l + dir.x * xScale,
        //         y: (t + dir.y * yScale),
        //         l: (dir.l * yScale) * aminateProgress,
        //         w: (dir.w * xScale) * aminateProgress,
        //         hw: (dir.hw * xScale) * aminateProgress,
        //         hh: (dir.hh * yScale) * aminateProgress
        //       }
        //       //starting path of the arrow from the start square to the end square and drawing the stroke
        //       ctx.beginPath();
        //       ctx.moveTo(d.x, d.y);
        //       ctx.lineTo(d.x, d.y - d.l);
        //       ctx.strokeStyle = cGreen1;
        //       ctx.lineWidth = d.w;
        //       ctx.stroke();
        //       // ctx.fill()
        //       //starting a new path from the head of the arrow to one of the sides of the point
        //       ctx.beginPath();
        //       ctx.strokeStyle = cGreen1;
        //       ctx.fillStyle = cGreen1;
        //       ctx.lineWidth = 2;
        //       ctx.moveTo(d.x, d.y - d.l - d.hh);
        //       ctx.lineTo(d.x - d.hw / 2, d.y - d.l);
        //       ctx.lineTo(d.x + d.hw / 2, d.y - d.l);
        //       ctx.lineTo(d.x, d.y - d.l - d.hh);
        //       ctx.stroke();
        //       ctx.fill()
        //     }
        //   }
        // })
        this.renderChart({
            labels: ['', '', '', '0', '', '', ''],
            datasets: [{
                    // label: 'Data One',
                    lineTension: 0.5,
                    borderColor: cWhite1,
                    // backgroundColor: cGreen1,
                    data: [null, null, 0, 90, 0, null, null]
                }]
        }, {
            maintainAspectRatio: false,
            layout: {
                padding: {
                    left: 50,
                    right: 20,
                    top: 0,
                    bottom: 0
                }
            },
            elements: {
                point: {
                    radius: 0
                },
                arrow: {
                    db: 80,
                    color: cWhite1,
                    fontStyle: 'Lato',
                    sidePadding: 50 //Default 20 (as a percentage)
                }
            },
            responsive: true,
            legend: {
                display: false,
            },
            scales: {
                yAxes: [{
                        ticks: {
                            // Include a dollar sign in the ticks
                            callback: function (value, index, values) {
                                return value + ' dB';
                            }
                        },
                        position: 'left'
                    }]
            },
        });
    }
};
chart = tslib_1.__decorate([
    Component({ extends: Line })
], chart);
export default chart;
